<template>
    <div>
        <MeetingForm
            ref="meetingFormRef"
            :product-code="productCode"
            :region.sync="meeting.region"
            :city.sync="meeting.city"
            :office.sync="meeting.office"
            :address.sync="meeting.address"
            :date.sync="meeting.date"
            :time.sync="meeting.time"
            :hideMeetingType="!isOver24yo"
            :way-to-get.sync="wayToGet"
            :noDateTime="wayToGet === EWayToGet.OFFICE"
            mb-only
            @status="(status) => meetingFormValid = status === EMeetingValidationStatus.VALID"
            @city-title="(val) => meeting.cityTitle = val"
            @delivery-type="(val) => meeting.deliveryType = val"
            @unavailable-office-pending="(val) => loading = val"
            @workDays="officeShedule = $event"
            @office-address="officeAddress = $event"
            @update:address-object="(val) => meeting.addressObject = val"
        >
            <template #wayToGetInput="{ value, setValue }">
                <ui-image-box-switcher
                    :items="[
                        {
                            value: 'office',
                            label: 'В офисе',
                            image: 'office-glass-new',
                        },
                        {
                            value: 'delivery',
                            label: 'С доставкой',
                            image: 'delivery-glass',
                        },
                    ]"
                    mobile-block
                    :value="value"
                    @input="setValue"
                />
            </template>
            <template #noCitiesDeliveryNotice>
                <notice-attention>
                    Если ваш город отсутствует в списке, обратитесь в <a href="/location/" class="link" target="_blank">ближайший офис</a>
                </notice-attention>
            </template>
            <template v-if="isOver24yo" #noCitiesOfficeNotice>
                <notice-attention>
                    <p>Если ваш город отсутствует в списке, выберите открытие счета с доставкой</p>
                    <a href="#" class="button button_min button_gray-light text-decoration-none _mt-8" @click.prevent="wayToGet = EWayToGet.DELIVERY">Продолжить с доставкой</a>
                </notice-attention>
            </template>
        </MeetingForm>

        <div class="form__split form__split-nopb _pt-40-24 _pb-24-0">
            <div class="form__split-title">
                <h3 class="h3 text-align-center-mob">Укажите электронный адрес</h3>
            </div>
            <div class="form__split-fields">
                <div class="form__item form__item-wide">
                    <ui-form-field
                        label="Введите свой E-mail"
                        :errors="vuelidateErrorMesages['email']"
                        id="cards-form-email"
                        :value="$v.email.$model"
                    >
                        <template v-slot:default="{ id, errors }">
                            <UiTextInputSuggestions
                                :id="id"
                                :error="!!errors.length"
                                v-model="$v.email.$model"
                                name="email"
                                :suggestionType="ESuggestionTypes.EMAIL"
                            />
                        </template>
                    </ui-form-field>
                </div>

                <div class="form__group">
                    <DButton @click="sendForm" id="ym-deposit-step2" :disabled="!formValid">Продолжить</DButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
    import vuelidateMessages from '../../assets/js/vue/validationsMessages';
    import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes'
    import deliveryMixin from '../../assets/js/vue/mixins/deliveryMixin'
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import dayjs from 'dayjs'
    import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';
    import { EAppointmentDeliveryType, EWayToGet, EValidationStatus as EMeetingValidationStatus } from '../widgets/MeetingForm/const';
    import MeetingForm from '../widgets/MeetingForm/MeetingForm.vue';
    import { formatAddressForCallCenter } from '../../assets/js/vue/utlis/formatAddressForCallCenter';
    import { DButton } from '@ahml/domrfbank-ui/elements/DButton';

    export default {
        name: "CardsFormV2Step2",
        mixins: [validationMixin, deliveryMixin],
        props: {
            phone: {
                type: String,
                default: ''
            },
            birthdate: {
                type: String,
                default: ''
            },
            productCode: {
                type: String,
                require: true
            }
        },
        components: {
            UiTextInputSuggestions,
            MeetingForm,
            DButton
        },
        directives: {
            'blur-check': {
                bind: (el, binding, vnode) => {
                    el.addEventListener('blur', () => {
                        let path = el.getAttribute('data-model-path');
                        path = path.split('.').reduce((o,i)=>o[i], vnode.context.$v);
                        path.$touch();
                    })
                },
            },
        },
        data() {
            return {
                url: '/rest/v1/deposit/combo/with-card',
                ESuggestionTypes,
                officeAddress: '',
                officeShedule: '',
                email: '',
                meetingFormValid: false,
                meeting: {
                    region: '',
                    city: '',
                    cityTitle: '',
                    office: '',
                    address: '',
                    date: '',
                    time: '',
                    deliveryType: '',
                    addressObject: undefined,
                },
                EWayToGet,
                wayToGet: EWayToGet.OFFICE,
                EMeetingValidationStatus,
            }
        },
        validations() {
            return {
                email: {required, email},
            }
        },
        methods: {
            convertDateToEng(val) {
                return val.replace(/\./g, '-').split('-').reverse().join('-');
            },
            sendForm() {
                this.$emit('setExtraData', this.extraData);

                if (this.meeting.deliveryType === EAppointmentDeliveryType.COURIER) {
                    this.$emit('sendStep', this.formData, 3);
                } else {
                    this.$emit('sendStep', this.formData, 2);
                }
            },
        },
        computed: {
            vuelidateErrorMesages() {
                return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
            },
            isOver24yo() {
                if (!this.birthdate) return true;
                let age = dayjs(this.convertDateToEng(this.birthdate));
                let minAge = age.add(24, 'year');

                return dayjs().isAfter(minAge);
            },
            extraData() {
                return {
                    officeShedule: this.officeShedule,
                    officeAddress: this.officeAddress,
                    isDelivery: this.wayToGet === EWayToGet.DELIVERY,
                    deliveryType: this.meeting.deliveryType,
                    email: this.email,
                    meeting: this.meeting
                }
            },
            cardType() {
                let type;

                if (this.wayToGet === EWayToGet.OFFICE || (this.wayToGet === EWayToGet.DELIVERY && this.meeting.deliveryType === EAppointmentDeliveryType.MB)) {
                    type = 'Моменталка';
                } else if (this.wayToGet === EWayToGet.DELIVERY && this.meeting.deliveryType === EAppointmentDeliveryType.COURIER) {
                    type = 'Персонка';
                }

                return type;
            },
            formData() {
                let data = {
                    data: {
                        type: "debitCard",
                        attributes: {
                            email: this.email,
                            cardType: this.cardType,
                            appointment: {
                                product: this.productCode,
                                deliveryType: this.meeting.deliveryType,
                                city: this.meeting.cityTitle,
                                region: this.meeting.region,
                            }
                        }
                    }
                }

                if (this.wayToGet === EWayToGet.OFFICE) {
                    data.data.attributes.appointment.office = this.meeting.office;
                } else {
                    data.data.attributes.appointment.interval = this.meeting.time;
                    data.data.attributes.appointment.address = formatAddressForCallCenter(this.meeting.address, this.meeting.addressObject);
                    data.data.attributes.appointment.date = this.meeting.date;
                }

                return data;
            },
            formValid() {
                return this.meetingFormValid && !this.$v.$invalid;
            },
        },
        watch: {
            isOver24yo(val) {
                if (val) this.wayToGet = EWayToGet.OFFICE;
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .form__scope {
        @include mobile {
            border-radius: inherit;
        }
    }

    .form__row, .form__group {
        @include fluid('margin-bottom', 24px);
    }

    .form__col {
        @include mobile {
            @include fluid('margin-bottom', 24px);
        }
    }

    .form__col:last-child {
        @include mobile {
            margin-bottom: 0px;
        }
    }

    .form__split {
        @include fluid('padding-bottom', 24px);
    }
</style>
